import type { AssetStatus } from '../../../shared/types'
import { useTranslation } from '../../hooks/useTranslation'

const statusStyles: Record<AssetStatus, string> = {
  active: 'bg-green-100 text-green-700',
  maintenance: 'bg-yellow-100 text-yellow-700',
  decommissioned: 'bg-gray-100 text-gray-600',
}

export function AssetStatusBadge({ status }: { status: AssetStatus }) {
  const { t } = useTranslation()

  return (
    <span className={`inline-flex items-center rounded-full px-2 py-1 text-xs font-medium ${statusStyles[status]}`}>
      {t(`status.${status}`)}
    </span>
  )
}
